import { ReactElement } from 'react';
import { Row, Col, Statistic, Tooltip } from 'antd';
import { Typography, StatusBox } from 'iglooform';
import { TooltipFilled } from 'iglooicon';
import { withdrawalStatusTypes, withdrawalStatus } from '@/utils/status';
import { useIntl, FormattedMessage } from 'react-intl';
import './cash-out-history-item.less';
import moment from 'moment';

const currentLang = localStorage.getItem('selected_lang');

interface IEarningCardOutCardHiistory {
  history: any;
  query: any;
  isPc: boolean;
}

const CashOutHistoryItem = ({
  history,
  query,
  isPc,
}: IEarningCardOutCardHiistory): ReactElement => {
  const { formatMessage } = useIntl();

  return isPc ? (
    <div className="history-detail-box" key={history.id}>
      <section className="cashout-title-container">
        <Typography level="body1" className="requested-time">
          {moment(history.requested_time * 1000).format('DD/MM/YYYY')}
        </Typography>
        <section className="status-box">
          <StatusBox type={withdrawalStatusTypes[history.status]}>
            <FormattedMessage {...withdrawalStatus[history.status]} />
          </StatusBox>
        </section>
        {history.note && history.status === 'WithdrawalRejected' && (
          <section className="reject-reason-icon">
            <Tooltip placement="top" title={history.note}>
              <TooltipFilled style={{ color: '#999', fontSize: '24px' }} />
            </Tooltip>
          </section>
        )}
      </section>
      <section className="detail-content-container">
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col span={6}>
            <Typography level="body1" className="content-title">
              {formatMessage({ id: 'Reference No.' })}
            </Typography>
          </Col>
          <Col span={6}>
            <Typography level="body1" className="content-title">
              {formatMessage({ id: 'Cash-out Request Amount' })}
            </Typography>
          </Col>
          <Col span={6}>
            <Typography level="body1" className="content-title">
              {formatMessage({ id: '10% Income Tax' })}
            </Typography>
          </Col>
          <Col span={6}>
            <Typography level="body1" className="content-title">
              {formatMessage({ id: 'Net Cash-out Amount' })}
            </Typography>
          </Col>
        </Row>
        <Row
          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          style={{ marginTop: '10px' }}
        >
          <Col span={6}>
            <Typography level="body1" className="content">
              {history.reference_no}
            </Typography>
          </Col>
          <Col span={6}>
            <Statistic
              value={history.amount}
              suffix={formatMessage({ id: 'VND' })}
              groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
              decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
              className="content"
            />
          </Col>
          <Col span={6}>
            <Statistic
              value={history.tax_amount}
              suffix={formatMessage({ id: 'VND' })}
              prefix="-"
              groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
              decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
              className="content"
            />
          </Col>
          <Col span={6}>
            <Statistic
              value={history.actual_amount}
              suffix={formatMessage({ id: 'VND' })}
              groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
              decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
              className="content"
            />
          </Col>
        </Row>
      </section>
    </div>
  ) : (
    <div className="history-detail-box-h5">
      <section className="top-box">
        <Typography level="body2" className="requested-time">
          {moment(history.requested_time * 1000).format('DD/MM/YYYY')}
        </Typography>
        <section className="status-box">
          <StatusBox type={withdrawalStatusTypes[history.status]}>
            <FormattedMessage {...withdrawalStatus[history.status]} />
          </StatusBox>
          {history.note && history.status === 'WithdrawalRejected' && (
            <section style={{ float: 'right', marginLeft: '4px' }}>
              <Tooltip placement="top" title={history.note}>
                <TooltipFilled style={{ color: '#999', fontSize: '24px' }} />
              </Tooltip>
            </section>
          )}
        </section>
      </section>
      <section className="bottom-box">
        <Typography level="body2" className="content-title">
          {formatMessage({ id: 'Reference No.' })}
        </Typography>
        <section className="status-box">
          <Typography level="body2" className="content">
            {history.reference_no}
          </Typography>
        </section>
      </section>
      <section className="bottom-box">
        <Typography level="body2" className="content-title">
          {formatMessage({ id: 'Cash-out Request Amount' })}
        </Typography>
        <section className="status-box">
          <Statistic
            value={history.amount}
            suffix={formatMessage({ id: 'VND' })}
            groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
            decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
            className="content"
          />
        </section>
      </section>
      <section className="bottom-box">
        <Typography level="body2" className="content-title">
          {formatMessage({ id: '10% Income Tax' })}
        </Typography>
        <section className="status-box">
          <Statistic
            value={history.tax_amount}
            suffix={formatMessage({ id: 'VND' })}
            prefix="-"
            groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
            decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
            className="content"
          />
        </section>
      </section>
      <section className="bottom-box">
        <Typography level="body2" className="content-title">
          {formatMessage({ id: 'Net Cash-out Amount' })}
        </Typography>
        <section className="status-box">
          <Statistic
            value={history.actual_amount}
            suffix={formatMessage({ id: 'VND' })}
            groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
            decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
            className="content"
          />
        </section>
      </section>
    </div>
  );
};

export default CashOutHistoryItem;
